'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
require('lodash/compact');
require('lodash/isArray');
require('lodash/last');
var debounce = _interopDefault(require('lodash/debounce'));
var times = _interopDefault(require('lodash/times'));

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function useInterval(callback, delay) {
  var savedCallback = React.useRef(function () {}); // Remember the latest callback.

  React.useEffect(function () {
    savedCallback.current = callback;
  }, [callback]); // Set up the interval.

  React.useEffect(function () {
    function tick() {
      savedCallback.current();
    }

    if (delay !== null) {
      var id = setInterval(tick, delay);
      return function () {
        return clearInterval(id);
      };
    }

    return undefined;
  }, [delay]);
}

function usePrevious(value) {
  var ref = React.useRef();
  React.useEffect(function () {
    ref.current = value;
  });
  return ref.current;
}

function useWindowDimensions() {
  var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 300;

  var _useState = React.useState({
    height: 0,
    width: 0
  }),
      _useState2 = _slicedToArray(_useState, 2),
      dimensions = _useState2[0],
      setDimensions = _useState2[1];

  React.useEffect(function () {
    var update = function update() {
      return setDimensions({
        height: window.innerHeight,
        width: window.innerWidth
      });
    };

    var handleResize = debounce(update, delay);
    window.addEventListener('resize', handleResize);
    update();
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, [delay]);
  return dimensions;
}

var Component = function Component(_ref) {
  var _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      _ref$time = _ref.time,
      time = _ref$time === void 0 ? 0 : _ref$time,
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 1000 : _ref$timeout,
      _ref$onTick = _ref.onTick,
      onTick = _ref$onTick === void 0 ? function () {
    return null;
  } : _ref$onTick,
      _ref$onFinish = _ref.onFinish,
      onFinish = _ref$onFinish === void 0 ? function () {
    return null;
  } : _ref$onFinish,
      _ref$stop = _ref.stop,
      stop = _ref$stop === void 0 ? false : _ref$stop;

  var _useState = React.useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      elapsedTime = _useState2[0],
      setElapsedTime = _useState2[1];

  var remainingTime = time - elapsedTime / 1000;
  var isActive = active && remainingTime > 0 ? timeout : null;
  var prev = usePrevious(isActive);
  useInterval(function () {
    if (!stop) {
      onTick(Math.max(remainingTime - timeout / 1000, 0));
      setElapsedTime(elapsedTime + timeout);
    }
  }, isActive);
  React.useEffect(function () {
    if (prev !== null && isActive === null && elapsedTime > 0) {
      onFinish();
    }
  }, [isActive]);
  return null;
};

var Countdown = React.memo(Component);

var LinearGradient = function LinearGradient(_ref) {
  var children = _ref.children,
      _ref$colors = _ref.colors,
      colors = _ref$colors === void 0 ? [] : _ref$colors,
      _ref$deg = _ref.deg,
      deg = _ref$deg === void 0 ? 90 : _ref$deg;
  var division = 100 / (colors.length - 1);

  var distributeColor = function distributeColor(color, index) {
    return "".concat(color, " ").concat(index * division, "%");
  };

  var colorsString = ["".concat(deg, "deg")].concat(_toConsumableArray(colors.map(distributeColor)));

  var styles = _objectSpread2({}, children.props.style, {
    backgroundImage: "linear-gradient(".concat(colorsString.join(', '), ")")
  });

  return React.cloneElement(children, _objectSpread2({}, children.props, {
    style: styles
  }));
};

var boxStyles = {
  alignItems: 'stretch',
  display: 'flex',
  flexBasis: 0,
  flexGrow: 1,
  flexShrink: 1,
  minHeight: 'min-content'
};

var MasonryComponent = function MasonryComponent(_ref) {
  var children = _ref.children,
      _ref$fallback = _ref.fallback,
      fallback = _ref$fallback === void 0 ? 2 : _ref$fallback,
      _ref$adjust = _ref.adjust,
      adjust = _ref$adjust === void 0 ? 0 : _ref$adjust,
      _ref$minColumnWidth = _ref.minColumnWidth,
      minColumnWidth = _ref$minColumnWidth === void 0 ? 300 : _ref$minColumnWidth,
      props = _objectWithoutProperties(_ref, ["children", "fallback", "adjust", "minColumnWidth"]);

  var wrapper = React.useRef(null);
  var initialWidth = fallback * minColumnWidth;

  var _useState = React.useState(initialWidth),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var _useWindowDimensions = useWindowDimensions(),
      width = _useWindowDimensions.width;

  React.useEffect(function () {
    if (wrapper.current) {
      var bounding = wrapper.current.getBoundingClientRect();
      setState(bounding.width);
    }
  }, [width]);
  var columns = Math.round(state / minColumnWidth);
  return React__default.createElement("div", _extends({
    className: "masonry-wrapper"
  }, props, {
    style: _objectSpread2({}, boxStyles, {
      maxWidth: '100%'
    }),
    ref: wrapper
  }), times(columns, function (index) {
    var isLast = index === columns - 1;
    return React__default.createElement("div", {
      style: _objectSpread2({}, boxStyles, {
        flexDirection: 'column',
        marginRight: isLast ? -1 : 0
      }),
      key: "tile-".concat(index)
    }, React__default.Children.toArray(children).filter(function (_child, filterIndex) {
      return (filterIndex + index + (columns - adjust)) % columns === 0;
    }).map(function (child, idx) {
      return React.cloneElement(child, _objectSpread2({}, child.props, {
        key: idx
      }));
    }));
  }));
};

var Masonry = React.memo(MasonryComponent);

exports.Countdown = Countdown;
exports.LinearGradient = LinearGradient;
exports.Masonry = Masonry;
